import { Box, Grid, Typography } from "@mui/material";
import "../../assets/css/subHeader.css";
import "../../App.css";

const Subheader = ({ internalStep, delegation }) => {
  const stepPercentages = {
    STEP0: 10,
    STEP1: 30,
    STEP2: 50,
    STEP3: 60,
    STEP4: 70,
    STEP5: 80,
    STEP6: 80,
    STEP7: 90,
    STEP8: 100,
  };

  let stepKey = internalStep;

  if (internalStep === "STEP8") {
    stepKey = "STEP8";
  }

  // if (delegation?.signatureMethod === "DIGITAL") {
  //   if (internalStep === "STEP5") {
  //     stepKey = "STEP6";
  //   }
  //   if (internalStep === "STEP6") {
  //     stepKey = "STEP6";
  //   }
  // }

  const percentage = stepPercentages[stepKey] || 0;

  const getColor = (value) => (value < 100 ? "#1b2838" : "#4caf50");

  return (
    <Grid
      className="bg-light-grey container-subHeader"
      container
      alignItems="center"
      sx={{ height: "50px", backgroundColor: "#e0e0e0" }}
    >
      <Grid item xs={12} display="flex" alignItems="center">
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Box
            sx={{
              width: "100%",
              paddingX: { xs: "20px", md: "50px" },
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                height: "10px",
                backgroundColor: "#ccc",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  width: `${percentage}%`,
                  height: "100%",
                  backgroundColor: getColor(percentage),
                  transition: "width 0.3s ease-in-out",
                }}
              />
            </Box>

            <Typography
              sx={{
                fontSize: { xs: "12px", sm: "14px", md: "16px" },
                marginLeft: 2,
                whiteSpace: "nowrap",
                userSelect: "none",
                marginTop: "-2px",
              }}
            >
              {percentage}% completato
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Subheader;
